import { Badge, MantineColor, Tooltip } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SampleStatus } from '../data-access/types/sampling';

interface SampleStatusProps {
  status: SampleStatus;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'filled' | 'light' | 'outline' | 'dot';
}

const getSampleStatusColor = (status: SampleStatus): MantineColor => {
  switch (status) {
    case SampleStatus.PENDING:
      return 'yellow';
    case SampleStatus.SENT:
      return 'blue';
    case SampleStatus.RECEIVED:
      return 'cyan';
    case SampleStatus.ANALYZED:
      return 'green';
    case SampleStatus.ERROR:
      return 'red';
    case SampleStatus.FINISHED:
      return 'teal';
    default:
      return 'gray';
  }
};

const getSampleStatusLabel = (status: SampleStatus): string => {
  switch (status) {
    case SampleStatus.PENDING:
      return 'sampling.sample-status.pending';
    case SampleStatus.SENT:
      return 'sampling.sample-status.sent';
    case SampleStatus.RECEIVED:
      return 'sampling.sample-status.received';
    case SampleStatus.ANALYZED:
      return 'sampling.sample-status.analyzed';
    case SampleStatus.ERROR:
      return 'sampling.sample-status.error';
    case SampleStatus.FINISHED:
      return 'sampling.sample-status.finished';
    default:
      return 'common:unknown';
  }
};

export const SampleStatusPill: FC<SampleStatusProps> = ({
  status,
  size = 'md',
  variant = 'light',
}) => {
  const { t } = useTranslation();
  const label = getSampleStatusLabel(status);

  return (
    <Tooltip label={t(label)} withArrow>
      <Badge
        color={getSampleStatusColor(status)}
        size={size}
        title={t(label)}
        variant={variant}
      >
        {t(label)}
      </Badge>
    </Tooltip>
  );
};

export { getSampleStatusColor, getSampleStatusLabel };
export default SampleStatusPill;
